const mapResultCount = (count = 0) => {
  if (!count) {
    return '0';
  }
  if (count < 51) {
    return '1 - 50';
  }
  if (count < 101) {
    return '51 - 100';
  }
  return '101+';
};

export default mapResultCount;
